import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const StarFilled = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 12C27.55 12 28 12.45 28 13H27.997C27.997 13.312 27.859 13.587 27.647 13.762L22.109 18.375L23.972 26.775C23.985 26.837 23.997 26.912 23.997 26.987C23.997 27.537 23.547 27.987 22.997 27.987C22.747 27.987 22.522 27.899 22.347 27.749L15.997 22.311L9.64699 27.749C9.47199 27.9 9.24699 27.987 8.99699 27.987C8.44699 27.987 7.99699 27.537 7.99699 26.987C7.99699 26.912 8.00999 26.85 8.02199 26.775L9.88499 18.375L4.35999 13.762C4.13599 13.588 3.99799 13.313 3.99799 13C3.99799 12.45 4.44799 12 4.99799 12H12.311L15.049 4.65C15.2 4.263 15.574 4 15.987 4C16.4 4 16.775 4.262 16.925 4.65L19.687 12H27Z" />
	</svg>
);

export default StarFilled;
